// This function will try to find the elements and move them.
const findAndMoveElements = () => {
  // We still check periodically because the buttons are loaded dynamically.
  console.log("Checking for elements...");
  
  const priceDescriptors = document.querySelector('.price-descriptors');
  // --- THIS IS THE CORRECTED LINE ---
  // We are now looking for the class '.shopify-payment-button' instead of the non-existent ID.
  const paymentButtonContainer = document.querySelector('.shopify-payment-button');

  // Check if both elements are finally available.
  if (priceDescriptors && paymentButtonContainer) {
    
    // --- SUCCESS! ---
    // The elements exist, so we can move them.
    paymentButtonContainer.insertAdjacentElement('afterend', priceDescriptors);
    
    // IMPORTANT: Stop the interval now that our job is done.
    clearInterval(checkInterval);
    
    console.log('Success! The payment button container was found and the element was moved.');
  }
};

// Start an interval to run our check function every 100ms.
const checkInterval = setInterval(findAndMoveElements, 100);

// As a safety measure, stop checking after 10 seconds.
setTimeout(() => {
  // This will only run if the element was not found in time.
  clearInterval(checkInterval); 
}, 10000);


///END MOVE OF UFE TO BELLOW SWATCHES


// ADA Compliance Script for UFE Elements

// Style for visually hidden labels accessible to screen readers
const style = document.createElement('style');
style.textContent = `
  .ada-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;
document.head.appendChild(style);

// Warn about duplicate IDs - this is a fundamental HTML issue to fix at the source.
console.warn("ADA Compliance Script: Found elements with duplicate IDs ('ufe-qty-control', 'uprice'). IDs MUST be unique in HTML for proper accessibility and functionality. Please fix this in the source HTML.");

let uniqueIdCounter = 0;
const ensureId = (element, baseName) => {
    if (!element.id) {
        element.id = `${baseName}-${uniqueIdCounter++}`;
    }
    return element.id;
};

const makeButtonAccessible = (element) => {
    if (element) {
        element.setAttribute('tabindex', '0');
        element.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                element.click();
            }
        });
    }
};

// Function to enhance swatch radio button keyboard navigation
const enhanceSwatchKeyboardNav = (swatchInput) => {
    if (swatchInput && swatchInput.type === 'radio') {
        swatchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                if (!swatchInput.checked) {
                    swatchInput.checked = true;
                    // Dispatch a change event to ensure any listeners are notified
                    swatchInput.dispatchEvent(new Event('change', { bubbles: true }));
                    console.log(`ADA script: Selected swatch '${swatchInput.value}' with Enter key.`);
                }
            }
        });
    }
};

const processUfeElement = (elementToProcess, isTriggerProduct = false) => {
    if (!elementToProcess) return;

    if (isTriggerProduct) {
        // Handle .ufe-trigger-product
        const triggerProductDiv = elementToProcess;
        const triggerImgSpan = triggerProductDiv.querySelector('.ufe-trigger-product--img .ufe-trigger-img');
        const triggerTitleMainSpan = triggerProductDiv.querySelector('.ufe-trigger-title > span'); // Main title text part
        const triggerTitleSmall = triggerProductDiv.querySelector('.ufe-trigger-title small');
        const triggerPriceMoney = triggerProductDiv.querySelector('.ufe-trigger-price .money');

        if (triggerImgSpan && triggerTitleMainSpan) {
            triggerImgSpan.setAttribute('aria-label', `Image of ${triggerTitleMainSpan.textContent.trim()}`);
            triggerImgSpan.setAttribute('role', 'img');
        }
        const triggerSvg = triggerProductDiv.querySelector('.ufe-trigger-product--img svg');
        if (triggerSvg) {
            triggerSvg.setAttribute('aria-hidden', 'true');
        }

        // Contrast improvements for .ufe-trigger-product
        if (triggerTitleMainSpan) {
            triggerTitleMainSpan.style.color = '#000000';
            triggerTitleMainSpan.style.fontWeight = 'bold';
        }
        if (triggerTitleSmall) {
            triggerTitleSmall.style.color = '#000000';
            triggerTitleSmall.style.fontWeight = 'bold';
        }
        if (triggerPriceMoney) {
            triggerPriceMoney.style.setProperty('color', '#000000', 'important');
            triggerPriceMoney.style.fontWeight = 'bold';
        }

    } else {
        // Handle .upsellWrapper (elementToProcess is an upsellWrapper)
        const upsellWrapper = elementToProcess;
        const itemIndex = uniqueIdCounter; // Use global counter for unique IDs across wrappers

        const upsellImgSpan = upsellWrapper.querySelector('.upsellImg > span');
        const upsellTitleElement = upsellWrapper.querySelector('.upsellTitle > span'); // This is often the one acting as a button or main title
        const productTitleText = (upsellTitleElement && upsellTitleElement.textContent) ? upsellTitleElement.textContent.trim() : 'the displayed item';

        if (upsellImgSpan && upsellTitleElement) {
            upsellImgSpan.setAttribute('aria-label', `Image of ${productTitleText}`);
            upsellImgSpan.setAttribute('role', 'img');
        }
        
        // Contrast for upsell title
        if (upsellTitleElement) {
            upsellTitleElement.style.color = '#000000';
            upsellTitleElement.style.fontWeight = 'bold';
        }

        const upsellTitleButton = upsellWrapper.querySelector('.upsellTitle > span[role="button"].ufe-has-no-link');
        if (upsellTitleButton) { // This might be the same as upsellTitleElement
            makeButtonAccessible(upsellTitleButton);
            upsellTitleButton.setAttribute('aria-label', productTitleText);
            // Ensure its style is also updated if it's a separate element or if styling above didn't catch it
            upsellTitleButton.style.color = '#000000';
            upsellTitleButton.style.fontWeight = 'bold';
        }
        
        // Contrast for upsell price
        const upsellPriceMoney = upsellWrapper.querySelector('.upsellPrice .money');
        if (upsellPriceMoney) {
            upsellPriceMoney.style.setProperty('color', '#000000', 'important'); // Override inline green
            upsellPriceMoney.style.fontWeight = 'bold';
        }

        const quantityInput = upsellWrapper.querySelector('.ufe-quantity input.ufe-input');
        if (quantityInput) {
            const inputId = ensureId(quantityInput, `ufe-qty-input-${itemIndex}`);
            quantityInput.removeAttribute('aria-label'); // Remove aria-label, will use explicit label

            let label = upsellWrapper.querySelector(`label[for="${inputId}"]`);
            if (!label) {
                label = document.createElement('label');
                label.setAttribute('for', inputId);
                label.className = 'ada-sr-only';
                quantityInput.parentNode.insertBefore(label, quantityInput);
            }
            label.textContent = `Quantity for ${productTitleText}`;

            // Style for touch target size
            quantityInput.style.minHeight = '44px';
            quantityInput.style.paddingTop = '10px';
            quantityInput.style.paddingBottom = '10px';
            quantityInput.style.boxSizing = 'border-box';
        }

        const variantSelect = upsellWrapper.querySelector('select.ufe-input.ufe-variants');
        if (variantSelect) {
            const selectId = ensureId(variantSelect, `ufe-variant-select-${itemIndex}`);
            variantSelect.removeAttribute('aria-label'); // Remove aria-label, will use explicit label

            let label = upsellWrapper.querySelector(`label[for="${selectId}"]`);
            if (!label) {
                label = document.createElement('label');
                label.setAttribute('for', selectId);
                label.className = 'ada-sr-only';
                // Insert before the select, or its wrapper if it has one (e.g. .ufe-s)
                const selectParent = variantSelect.closest('.ufe-s') || variantSelect.parentNode;
                selectParent.parentNode.insertBefore(label, selectParent);

            }
            label.textContent = `Select option for ${productTitleText}`;
        }

        const quantityControls = upsellWrapper.querySelectorAll('.ufe-quantity > span[role="button"]');
        quantityControls.forEach(control => {
            makeButtonAccessible(control);
            const controlText = control.textContent.trim();
            let ariaLabel = '';
            if (controlText === '-') {
                ariaLabel = `Decrease quantity for ${productTitleText}`;
            } else if (controlText === '+') {
                ariaLabel = `Increase quantity for ${productTitleText}`;
            }
            if (ariaLabel) {
                control.setAttribute('aria-label', ariaLabel);
            }
            if (control.style.cursor === 'not-allowed') {
                control.setAttribute('aria-disabled', 'true');
            } else {
                control.removeAttribute('aria-disabled');
            }

            // Style for touch target size
            control.style.minWidth = '44px';
            control.style.minHeight = '44px';
            control.style.padding = '10px';
            control.style.display = 'inline-flex';
            control.style.alignItems = 'center';
            control.style.justifyContent = 'center';
            control.style.boxSizing = 'border-box';
        });

        const atcButton = upsellWrapper.querySelector('button.atcBtn');
        if (atcButton) {
            const atcButtonImgs = atcButton.querySelectorAll('img.ufe-ico');
            atcButtonImgs.forEach(img => {
                img.setAttribute('alt', ''); // Mark as decorative
            });
            const currentButtonTextSpan = atcButton.querySelector('span');
            if (currentButtonTextSpan) {
                atcButton.setAttribute('aria-label', `Yes, I want ${productTitleText}`);
            }
        }
        console.log(`ADA script processed upsellWrapper for: ${productTitleText}`);
    }
};

const removeProblematicYotpoDropdowns = (scanRootNode) => {
    // Selector for the placeholder span within the Yotpo dropdown component.
    const dropdownPlaceholders = scanRootNode.querySelectorAll('span[id^="yotpo-dropdown-"].yotpo-dropdown-placeholder');

    dropdownPlaceholders.forEach(placeholder => {
        const componentToRemove = placeholder.parentElement;
        if (componentToRemove && componentToRemove.parentElement) { // Ensure parent exists and is not the document root itself
            // Check if the parent has a data-v attribute (common for Vue component roots)
            const isLikelyYotpoComponentParent = Array.from(componentToRemove.attributes).some(attr => attr.name.startsWith('data-v-'));

            // Check if this parent contains other known parts of the Yotpo dropdown or the placeholder itself is clearly Yotpo.
            if (isLikelyYotpoComponentParent &&
                (componentToRemove.querySelector('.yotpo-selected-value') ||
                 componentToRemove.querySelector('.yotpo-dropdown-content-wrapper') ||
                 placeholder.id.startsWith("yotpo-dropdown-"))) {
                console.log(`ADA script: Removing Yotpo sort dropdown component (parent: ${componentToRemove.tagName}, id: ${componentToRemove.id || 'N/A'}, class: "${componentToRemove.className || 'N/A'}") containing placeholder: ${placeholder.id}`);
                componentToRemove.remove();
            } else {
                let parentDetails = `tag: ${componentToRemove.tagName}`;
                if (componentToRemove.id) parentDetails += `, id: ${componentToRemove.id}`;
                if (componentToRemove.className) parentDetails += `, class: "${componentToRemove.className}"`;
                let childDetails = `selected_value: ${!!componentToRemove.querySelector('.yotpo-selected-value')}, content_wrapper: ${!!componentToRemove.querySelector('.yotpo-dropdown-content-wrapper')}, placeholder_id_is_yotpo: ${placeholder.id.startsWith("yotpo-dropdown-")}`;
                console.warn(`ADA script: Found Yotpo placeholder ${placeholder.id}. Its parent (${parentDetails}) did not meet removal criteria (isLikelyYotpoParent: ${isLikelyYotpoComponentParent}, childChecks: ${childDetails}). Not removing.`);
            }
        } else if (componentToRemove && !componentToRemove.parentElement) {
             console.warn(`ADA script: Found Yotpo placeholder ${placeholder.id}, its parent is likely document.body or detached, or is the html element. Not removing directly.`);
        } else {
            console.warn(`ADA script: Found Yotpo dropdown placeholder ${placeholder.id} but it has no parentElement to inspect or remove.`);
        }
    });
};
const initAdaCompliance = () => {
    // Process any elements already in the DOM
    const initialTrigger = document.querySelector('.ufe-trigger-product');
    if (initialTrigger) {
        processUfeElement(initialTrigger, true);
    }
    document.querySelectorAll('.upsellWrapper').forEach(wrapper => processUfeElement(wrapper));

    // Process initially present PayPal buttons
    const initialPayPalButtons = document.querySelectorAll('shopify-paypal-button');
    initialPayPalButtons.forEach(button => {
        if (!button.hasAttribute('aria-label')) {
            button.setAttribute('aria-label', 'Checkout with PayPal');
            console.log('ADA script: Added aria-label to initially present shopify-paypal-button');
        }
    });

    // Process initially present product swatch radio buttons
    const initialSwatchInputs = document.querySelectorAll('input.opt-btn.js-option[type="radio"]');
    initialSwatchInputs.forEach(swatch => {
        enhanceSwatchKeyboardNav(swatch);
    });
    if (initialSwatchInputs.length > 0) {
        console.log(`ADA script: Enhanced keyboard navigation for ${initialSwatchInputs.length} initial product swatches.`);
    }

    // Remove problematic Yotpo dropdowns initially present
    removeProblematicYotpoDropdowns(document);
    console.log('ADA script: Initial check for Yotpo sort dropdowns complete.');

    // Observe the body for dynamically added UFE elements
    const observer = new MutationObserver((mutationsList, observerInstance) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if the added node itself is a ufe-trigger-product
                        if (node.matches && node.matches('.ufe-trigger-product')) {
                            console.log('ADA script: Detected new .ufe-trigger-product');
                            processUfeElement(node, true);
                        }
                        // Check if the added node itself is an upsellWrapper
                        if (node.matches && node.matches('.upsellWrapper')) {
                            console.log('ADA script: Detected new .upsellWrapper');
                            processUfeElement(node);
                        }
                        // Check for ufe-trigger-product within the added node
                        const triggersInNode = node.querySelectorAll ? node.querySelectorAll('.ufe-trigger-product') : [];
                        triggersInNode.forEach(trigger => {
                             console.log('ADA script: Detected new .ufe-trigger-product (child)');
                            processUfeElement(trigger, true);
                        });
                        // Check for upsellWrappers within the added node
                        const wrappersInNode = node.querySelectorAll ? node.querySelectorAll('.upsellWrapper') : [];
                        wrappersInNode.forEach(wrapper => {
                            console.log('ADA script: Detected new .upsellWrapper (child)');
                            processUfeElement(wrapper);
                        });

                        // --- Yotpo Specific Fixes ---
                        // Check for Yotpo scoreDropdownInput
                        if (node.matches && node.matches('#scoreDropdownInput')) {
                            console.log('ADA script: Detected #scoreDropdownInput');
                            node.setAttribute('role', 'textbox');
                            if (node.hasAttribute('readonly')) {
                                node.removeAttribute('aria-autocomplete');
                                console.log('ADA script: Removed aria-autocomplete from readonly #scoreDropdownInput');
                            }
                        }
                        // Check for #scoreDropdownInput within the added node
                        const yotpoScoreInput = node.querySelector ? node.querySelector('#scoreDropdownInput') : null;
                        if (yotpoScoreInput) {
                            console.log('ADA script: Detected #scoreDropdownInput (child)');
                            yotpoScoreInput.setAttribute('role', 'textbox');
                            if (yotpoScoreInput.hasAttribute('readonly')) {
                                yotpoScoreInput.removeAttribute('aria-autocomplete');
                                console.log('ADA script: Removed aria-autocomplete from readonly #scoreDropdownInput (child)');
                           }
                       }

                       // --- PayPal Button Specific Fixes ---
                       // Check if the added node itself is a shopify-paypal-button
                       if (node.matches && node.matches('shopify-paypal-button')) {
                           if (!node.hasAttribute('aria-label')) {
                               node.setAttribute('aria-label', 'Checkout with PayPal');
                               console.log('ADA script: Added aria-label to new shopify-paypal-button');
                           }
                       }
                       // Check for shopify-paypal-button within the added node
                       const payPalButtonsInNode = node.querySelectorAll ? node.querySelectorAll('shopify-paypal-button') : [];
                       payPalButtonsInNode.forEach(button => {
                           if (!button.hasAttribute('aria-label')) {
                               button.setAttribute('aria-label', 'Checkout with PayPal');
                               console.log('ADA script: Added aria-label to new shopify-paypal-button (child)');
                           }
                       });

                       // --- Product Swatch Radio Button Keyboard Navigation Enhancement ---
                       // Check if the added node itself is a product swatch radio input
                       if (node.matches && node.matches('input.opt-btn.js-option[type="radio"]')) {
                           enhanceSwatchKeyboardNav(node);
                           console.log('ADA script: Enhanced keyboard nav for new product swatch radio.');
                       }
                       // Check for product swatch radio inputs within the added node
                       const swatchInputsInNode = node.querySelectorAll ? node.querySelectorAll('input.opt-btn.js-option[type="radio"]') : [];
                       swatchInputsInNode.forEach(swatch => {
                           enhanceSwatchKeyboardNav(swatch);
                           console.log('ADA script: Enhanced keyboard nav for new product swatch radio (child).');
                       });

                        // Remove problematic Yotpo dropdowns if added dynamically
                        removeProblematicYotpoDropdowns(node); // This scans the added node and its children
                   }
               });
           }
       }
   });

    observer.observe(document.body, { childList: true, subtree: true });
    console.log('ADA compliance MutationObserver initialized.');
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdaCompliance);
} else {
    // DOMContentLoaded has already fired
    initAdaCompliance();
}



// Select all option labels that might be sold out
const optionLabels = document.querySelectorAll('.opt-label--swatch, .opt-label--btn');

optionLabels.forEach(label => {
    // Check if the label is marked as sold out (either by title or other indicator)
    if (label.title === "Sold out" || label.classList.contains('is-unavailable')) {
        // Hide the label
        label.style.display = 'none';
        
        // Hide the corresponding input
        const inputId = label.getAttribute('for');
        if (inputId) {
            const inputElement = document.getElementById(inputId);
            if (inputElement) {
                inputElement.style.display = 'none';
            }
        }
    }
});